(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/flags/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/lb-ui/flags/assets/javascripts/shared.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var svs = svs || {};

(function (svs) {
  'use strict';

  svs.lb_ui = svs.lb_ui || {};
  svs.lb_ui.flags = svs.lb_ui.flags || {};
  var cdn = '';

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    var trinidad = require('trinidad-core').core;

    cdn = trinidad.options.cdn;
  } else {
    cdn = svs.core.config.data.svsconfig.cdn;
  }

  var availiableFlags = [{
    iso: 'ABW',
    name: 'Aruba',
    url: '/images/lb-ui/flags/abw-72be18b9e4e324f34150dc2800dafac4b0a20e70.svg'
  }, {
    iso: 'AFG',
    name: 'Afghanistan',
    url: '/images/lb-ui/flags/afg-cedf8bf6a4c2f9d83e1ca2feac2c3e1a0f89b2e3.svg'
  }, {
    iso: 'AGO',
    name: 'Angola',
    url: '/images/lb-ui/flags/ago-176fa6b59950a0c2c73b2e9924148d8270b87d20.svg'
  }, {
    iso: 'AIA',
    name: 'Anguilla',
    url: '/images/lb-ui/flags/aia-8f2fc6e9a07903144f8727246d41be7c34ed7311.svg'
  }, {
    iso: 'ALA',
    name: 'Åland Islands',
    url: '/images/lb-ui/flags/ala-ff929cea9fb24760b6b474ef3ae7912227be666a.svg'
  }, {
    iso: 'ALB',
    name: 'Albania',
    url: '/images/lb-ui/flags/alb-2bf77933e3af5a8ecabc0c2416451f3124530925.svg'
  }, {
    iso: 'AND',
    name: 'Andorra',
    url: '/images/lb-ui/flags/and-9da710b22e2e0932c67c85b038438aad5b52e21e.svg'
  }, {
    iso: 'ARE',
    name: 'United Arab Emirates',
    url: '/images/lb-ui/flags/are-c46270267a8dd42f2b5f499c437e889e452549b0.svg'
  }, {
    iso: 'ARG',
    name: 'Argentina',
    url: '/images/lb-ui/flags/arg-4229a9f8a5f9fb834530eff3aca6abbaa80bbbcc.svg'
  }, {
    iso: 'ARM',
    name: 'Armenia',
    url: '/images/lb-ui/flags/arm-25625ed5c81788da04bcdefa9e076c9038d8c7eb.svg'
  }, {
    iso: 'ASM',
    name: 'American Samoa',
    url: '/images/lb-ui/flags/asm-1fdf0b2ce993f2daf7656bd2f0b1a6a1c5e7bf91.svg'
  }, {
    iso: 'ATA',
    name: 'Antarctica',
    url: '/images/lb-ui/flags/ata-460d41e9538f9b93589505937c8dbcc9a39e7418.svg'
  }, {
    iso: 'ATF',
    name: 'French Southern and Antarctic Territories',
    url: '/images/lb-ui/flags/atf-3a1c01750ff6c629890ec1a424ef402b1ac62243.svg'
  }, {
    iso: 'ATG',
    name: 'Antigua And Barbuda',
    url: '/images/lb-ui/flags/atg-18da28f4cb8599cea01b1facf7131d7334d05bf5.svg'
  }, {
    iso: 'AUS',
    name: 'Australia',
    url: '/images/lb-ui/flags/aus-345fd8f9e84bd0aac49ed95a5e2505136fcef5d2.svg'
  }, {
    iso: 'AUT',
    name: 'Austria',
    url: '/images/lb-ui/flags/aut-1cb94c9accb5e89bbbed8c8011f5bd69e3069a97.svg'
  }, {
    iso: 'AZE',
    name: 'Azerbaijan',
    url: '/images/lb-ui/flags/aze-5808a4a4082652df382367f55d675e525a232e4f.svg'
  }, {
    iso: 'BDI',
    name: 'Burundi',
    url: '/images/lb-ui/flags/bdi-671cb8c4ed4235af1e2ddfdd79339bb1145209c2.svg'
  }, {
    iso: 'BEL',
    name: 'Belgium',
    url: '/images/lb-ui/flags/bel-122166db1afedc6ca8e07baf89c19d90b673ad9a.svg'
  }, {
    iso: 'BEN',
    name: 'Benin',
    url: '/images/lb-ui/flags/ben-be6a564729b4e19a1890e145548b8af74fb5a040.svg'
  }, {
    iso: 'BES',
    name: 'Bonaire, Saint Eustatius And Saba',
    url: '/images/lb-ui/flags/bes-c191f2d6f13d2d035d30c57f18303a7b420326c6.svg'
  }, {
    iso: 'BFA',
    name: 'Burkina Faso',
    url: '/images/lb-ui/flags/bfa-819063857d69a10fe5221bd1d5ec387e491881f3.svg'
  }, {
    iso: 'BGD',
    name: 'Bangladesh',
    url: '/images/lb-ui/flags/bgd-c023711dea9b9ef6f6f11dc9ec363854643807a5.svg'
  }, {
    iso: 'BGR',
    name: 'Bulgaria',
    url: '/images/lb-ui/flags/bgr-256cfdaf06ae60da71b3393a0ac4e1037329086b.svg'
  }, {
    iso: 'BHR',
    name: 'Bahrain',
    url: '/images/lb-ui/flags/bhr-488812ff39c40e13357c600f92808f3a7cbab63a.svg'
  }, {
    iso: 'BHS',
    name: 'Bahamas',
    url: '/images/lb-ui/flags/bhs-906682190dbb82b5cec718b3eee19292f7ec0441.svg'
  }, {
    iso: 'BIH',
    name: 'Bosnia &amp; Herzegovina',
    url: '/images/lb-ui/flags/bih-8d8ea20ce16b6eb8b4ebc6aff48922a97614b95f.svg'
  }, {
    iso: 'BLM',
    name: 'Saint Barthélemy',
    url: '/images/lb-ui/flags/blm-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'BLR',
    name: 'Belarus',
    url: '/images/lb-ui/flags/blr-a5e82b57703a81e0db772a6210ba978bad9134bc.svg'
  }, {
    iso: 'BLZ',
    name: 'Belize',
    url: '/images/lb-ui/flags/blz-eff0b3ac90a05d40ca9c605ba6345abf298fa02d.svg'
  }, {
    iso: 'BMU',
    name: 'Bermuda',
    url: '/images/lb-ui/flags/bmu-7a077f23e53cd500ffb44a932a04f9fd4fb965e8.svg'
  }, {
    iso: 'BOL',
    name: 'Bolivia, Plurinational State Of',
    url: '/images/lb-ui/flags/bol-5bfe536481465aacf876cad8805afbb38f9440e7.svg'
  }, {
    iso: 'BRA',
    name: 'Brazil',
    url: '/images/lb-ui/flags/bra-e7e2bbd7ffdae50f989c30809c4ea49f1ba5fad4.svg'
  }, {
    iso: 'BRB',
    name: 'Barbados',
    url: '/images/lb-ui/flags/brb-7e961f7f7d3ae3637fbb379e9bfa5fd9bea09784.svg'
  }, {
    iso: 'BRN',
    name: 'Brunei Darussalam',
    url: '/images/lb-ui/flags/brn-b063fccc0ea056646973384a2a62bf5919960e4b.svg'
  }, {
    iso: 'BTN',
    name: 'Bhutan',
    url: '/images/lb-ui/flags/btn-de079873ef6bc3b212e688877d1d3263c1c3ab29.svg'
  }, {
    iso: 'BVT',
    name: 'Bouvet Island',
    url: '/images/lb-ui/flags/bvt-adc6b6581018a956df38223f3ede0854e278fc2e.svg'
  }, {
    iso: 'BWA',
    name: 'Botswana',
    url: '/images/lb-ui/flags/bwa-dd04293588e409311c8f91a0bbc53815532700ea.svg'
  }, {
    iso: 'CAF',
    name: 'Central African Republic',
    url: '/images/lb-ui/flags/caf-c191d1e0dc4b68c7cdb45942c8b438625fe89484.svg'
  }, {
    iso: 'CAN',
    name: 'Canada',
    url: '/images/lb-ui/flags/can-93bd6d6905c706364bba82207d58e186d99d8e35.svg'
  }, {
    iso: 'CCK',
    name: 'Cocos (Keeling) Islands',
    url: '/images/lb-ui/flags/cck-b596d9aa09d35c191d26171727054c9bc668e931.svg'
  }, {
    iso: 'CHE',
    name: 'Switzerland',
    url: '/images/lb-ui/flags/che-a21416d11156ff2b2fc2e9a26b9d69b6382af1a0.svg'
  }, {
    iso: 'CHL',
    name: 'Chile',
    url: '/images/lb-ui/flags/chl-f6cbb6351559b6adc5494706ccf024989492ad50.svg'
  }, {
    iso: 'CHN',
    name: 'China',
    url: '/images/lb-ui/flags/chn-a323ac38c3dae9d9216c41dcc21342031bbd53d6.svg'
  }, {
    iso: 'CIV',
    name: 'Côte d&#x27;Ivoire',
    url: '/images/lb-ui/flags/civ-774f309e3f6fa0af31b106e9b4ccd990a5c21d2b.svg'
  }, {
    iso: 'CMR',
    name: 'Cameroon',
    url: '/images/lb-ui/flags/cmr-6d46d81e298d7719cdde473469cd044c850fda2d.svg'
  }, {
    iso: 'COD',
    name: 'Democratic Republic Of Congo',
    url: '/images/lb-ui/flags/cod-e35a45fda3967d41ca2fe4aef62d9ee391519fe6.svg'
  }, {
    iso: 'COG',
    name: 'Republic Of Congo',
    url: '/images/lb-ui/flags/cog-cd5a255445dfd4367a70edd378a46639d126f7ca.svg'
  }, {
    iso: 'COK',
    name: 'Cook Islands',
    url: '/images/lb-ui/flags/cok-f0dc7fb50d29b5ebb2c6ef9a63216606793e07d9.svg'
  }, {
    iso: 'COL',
    name: 'Colombia',
    url: '/images/lb-ui/flags/col-d23937487aeabdbdbb8742ac9576356e1d48a0d8.svg'
  }, {
    iso: 'COM',
    name: 'Comoros',
    url: '/images/lb-ui/flags/com-4cdcf3dab8350c8d34aaad987bbcf8e3527e7a90.svg'
  }, {
    iso: 'CPV',
    name: 'Cabo Verde',
    url: '/images/lb-ui/flags/cpv-343b0759db3c06ee293864c4cb132f32f68e3ebb.svg'
  }, {
    iso: 'CRI',
    name: 'Costa Rica',
    url: '/images/lb-ui/flags/cri-3d2126119a5251fba6d93a5ffd762f7543afa34f.svg'
  }, {
    iso: 'CUB',
    name: 'Cuba',
    url: '/images/lb-ui/flags/cub-a6cb5286f690e559b8587fb0196aa962e2b7fd51.svg'
  }, {
    iso: 'CUW',
    name: 'Curacao',
    url: '/images/lb-ui/flags/cuw-efe88527f1e153de3f447b3f4a34a86569c3d541.svg'
  }, {
    iso: 'CXR',
    name: 'Christmas Island',
    url: '/images/lb-ui/flags/cxr-07d6dc10cc98d4649b854f4e75720e9ad6ede772.svg'
  }, {
    iso: 'CYM',
    name: 'Cayman Islands',
    url: '/images/lb-ui/flags/cym-be9158c785b1cbffac93c207399d027b2d395489.svg'
  }, {
    iso: 'CYP',
    name: 'Cyprus',
    url: '/images/lb-ui/flags/cyp-96e579193f14475471c0ed40f5923cc08e54a26f.svg'
  }, {
    iso: 'CZE',
    name: 'Czech Republic',
    url: '/images/lb-ui/flags/cze-9525e6bc46f78a62e7066f35e60d89e9417c6843.svg'
  }, {
    iso: 'DEU',
    name: 'Germany',
    url: '/images/lb-ui/flags/deu-2d5289dd80421259fdc164557a1ba64d682dd81a.svg'
  }, {
    iso: 'DJI',
    name: 'Djibouti',
    url: '/images/lb-ui/flags/dji-37b1e48e3dcb25a2d206bad74bfa1777880260c0.svg'
  }, {
    iso: 'DMA',
    name: 'Dominica',
    url: '/images/lb-ui/flags/dma-d1811b67b4296e5b2b8ea825eea3087e3f39c07e.svg'
  }, {
    iso: 'DNK',
    name: 'Denmark',
    url: '/images/lb-ui/flags/dnk-989cd028d32393f438c48ced3210040069b80268.svg'
  }, {
    iso: 'DOM',
    name: 'Dominican Republic',
    url: '/images/lb-ui/flags/dom-d5f8d1b680b697bfed67d40bce0bb1ff03b5bb0c.svg'
  }, {
    iso: 'DZA',
    name: 'Algeria',
    url: '/images/lb-ui/flags/dza-79bf85becb33d74c7ca96f479e7915af8a09450b.svg'
  }, {
    iso: 'ECU',
    name: 'Ecuador',
    url: '/images/lb-ui/flags/ecu-200a12a3f171ef96a546760bce51d81c2a0f928c.svg'
  }, {
    iso: 'EGY',
    name: 'Egypt',
    url: '/images/lb-ui/flags/egy-873a482e1c37551f73f0019d07d78977499a5827.svg'
  }, {
    iso: 'ENG',
    name: '',
    url: '/images/lb-ui/flags/eng-e6d169538fb522d590b467374b216c9acd59ae16.svg'
  }, {
    iso: 'ERI',
    name: 'Eritrea',
    url: '/images/lb-ui/flags/eri-292c568f14e8be35d4fcb2360110b3166e134a99.svg'
  }, {
    iso: 'ES-CT',
    name: '',
    url: '/images/lb-ui/flags/es-ct-afbd39cf64f0723114257f07d6873547e148c599.svg'
  }, {
    iso: 'ESH',
    name: 'Western Sahara',
    url: '/images/lb-ui/flags/esh-8f4abd1572ebd5a2a69d88a2385de729b5f2656f.svg'
  }, {
    iso: 'ESP',
    name: 'Spain',
    url: '/images/lb-ui/flags/esp-607ec923ce85c048b3e2073d6194c2410911617d.svg'
  }, {
    iso: 'EST',
    name: 'Estonia',
    url: '/images/lb-ui/flags/est-5703ded111275d6f48b9bcb38e544d95e95933c4.svg'
  }, {
    iso: 'ETH',
    name: 'Ethiopia',
    url: '/images/lb-ui/flags/eth-e4c551ce7c31be603947719c3d74ebd677ad4d44.svg'
  }, {
    iso: 'FIN',
    name: 'Finland',
    url: '/images/lb-ui/flags/fin-ed187459608f27c865666dbe553539cce57fbd0f.svg'
  }, {
    iso: 'FJI',
    name: 'Fiji',
    url: '/images/lb-ui/flags/fji-1f874e1c6cedd065cae5742a843954ad3876f49e.svg'
  }, {
    iso: 'FLK',
    name: 'Falkland Islands',
    url: '/images/lb-ui/flags/flk-ddbbda9329910c8a358b71a24c7c4e96d953d136.svg'
  }, {
    iso: 'FRA',
    name: 'France',
    url: '/images/lb-ui/flags/fra-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'FRO',
    name: 'Faroe Islands',
    url: '/images/lb-ui/flags/fro-8b00b4206fa4fa9c5f074c6afcfd925bb59d00f1.svg'
  }, {
    iso: 'FSM',
    name: 'Micronesia, Federated States Of',
    url: '/images/lb-ui/flags/fsm-f2244ccf71c2c3ae7c268390c83178981f7c520d.svg'
  }, {
    iso: 'GAB',
    name: 'Gabon',
    url: '/images/lb-ui/flags/gab-a6d81a4c4677640791ed46bc98760b1c49b01a53.svg'
  }, {
    iso: 'GBR',
    name: 'United Kingdom',
    url: '/images/lb-ui/flags/gbr-42fba90fca80cdc1e587ab6528cf86d6a7038fe6.svg'
  }, {
    iso: 'GEO',
    name: 'Georgia',
    url: '/images/lb-ui/flags/geo-154badafc2231436e5b61dec8c72efee4df22c1a.svg'
  }, {
    iso: 'GGY',
    name: 'Guernsey',
    url: '/images/lb-ui/flags/ggy-667b232682f4b52fdf321714494405833b6fee95.svg'
  }, {
    iso: 'GHA',
    name: 'Ghana',
    url: '/images/lb-ui/flags/gha-a7750f282b91b1c7da9867311d6b001365c60c08.svg'
  }, {
    iso: 'GIB',
    name: 'Gibraltar',
    url: '/images/lb-ui/flags/gib-4ad2fdb298e2acec626b9d2bef6497686ecb57c1.svg'
  }, {
    iso: 'GIN',
    name: 'Guinea',
    url: '/images/lb-ui/flags/gin-1748436d8b83e77cccf7ad61332819679dec019b.svg'
  }, {
    iso: 'GLP',
    name: 'Guadeloupe',
    url: '/images/lb-ui/flags/glp-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'GMB',
    name: 'Gambia',
    url: '/images/lb-ui/flags/gmb-e8c1bafc601116691a6c623a68c3896381390195.svg'
  }, {
    iso: 'GNB',
    name: 'Guinea-bissau',
    url: '/images/lb-ui/flags/gnb-10275c670c76156221e0c17e9ebccdaba43065f4.svg'
  }, {
    iso: 'GNQ',
    name: 'Equatorial Guinea',
    url: '/images/lb-ui/flags/gnq-aaa60796a0964d0609c1819760ae1e692b18ec65.svg'
  }, {
    iso: 'GRC',
    name: 'Greece',
    url: '/images/lb-ui/flags/grc-1e94da1fe89630f8f755784edf95153e28e30c1e.svg'
  }, {
    iso: 'GRD',
    name: 'Grenada',
    url: '/images/lb-ui/flags/grd-4d0ff3f30fde0eea056192de86eb3f9c2a919d8c.svg'
  }, {
    iso: 'GRL',
    name: 'Greenland',
    url: '/images/lb-ui/flags/grl-3dd0a0425975b5911f3d255f8ff98115da53216a.svg'
  }, {
    iso: 'GTM',
    name: 'Guatemala',
    url: '/images/lb-ui/flags/gtm-a036b5d7a4a149c05a07547bcddc879a813acb44.svg'
  }, {
    iso: 'GUF',
    name: 'French Guiana',
    url: '/images/lb-ui/flags/guf-037019535ef97b585f03b805f94aed175235d4b0.svg'
  }, {
    iso: 'GUM',
    name: 'Guam',
    url: '/images/lb-ui/flags/gum-c36b892b1802653bdfc00b3319de81fbbd949dd8.svg'
  }, {
    iso: 'GUY',
    name: 'Guyana',
    url: '/images/lb-ui/flags/guy-7bdc12088f2c7757ae0005b9a6692c34638ba98e.svg'
  }, {
    iso: 'HKG',
    name: 'Hong Kong',
    url: '/images/lb-ui/flags/hkg-fcb9234b355f5ce254b99b3a202b00800ee9199d.svg'
  }, {
    iso: 'HMD',
    name: 'Heard Island And McDonald Islands',
    url: '/images/lb-ui/flags/hmd-f1c2f402e7485880767c2216574b5e9137cd2c3e.svg'
  }, {
    iso: 'HND',
    name: 'Honduras',
    url: '/images/lb-ui/flags/hnd-750aff36b7ccab2bb8e491a2a3581effbf897e84.svg'
  }, {
    iso: 'HRV',
    name: 'Croatia',
    url: '/images/lb-ui/flags/hrv-7ef981db3db05dabc9b81169bfe49be0acf73125.svg'
  }, {
    iso: 'HTI',
    name: 'Haiti',
    url: '/images/lb-ui/flags/hti-e6eaf4a5e783889b6e45b88798fc0447c8dc99f7.svg'
  }, {
    iso: 'HUN',
    name: 'Hungary',
    url: '/images/lb-ui/flags/hun-b10244a50a96026100c74b8f5e066202a55a81d7.svg'
  }, {
    iso: 'IDN',
    name: 'Indonesia',
    url: '/images/lb-ui/flags/idn-3f59c1ea2846c99320543d4933b519b7aa0e1834.svg'
  }, {
    iso: 'IMN',
    name: 'Isle Of Man',
    url: '/images/lb-ui/flags/imn-24680d385bb17b9e6171fa2cbfe4872a76f36ed5.svg'
  }, {
    iso: 'IND',
    name: 'India',
    url: '/images/lb-ui/flags/ind-ee191d8fb5eab6f45e0a5c6d130e8eca5298fbef.svg'
  }, {
    iso: 'INT',
    name: '',
    url: '/images/lb-ui/flags/int-d7c93097ec99d9444774745e77ee6f7ca65f9462.svg'
  }, {
    iso: 'IOT',
    name: 'British Indian Ocean Territory',
    url: '/images/lb-ui/flags/iot-03489584290315e47ee709a2fbea16657fdbdfb3.svg'
  }, {
    iso: 'IRL',
    name: 'Ireland',
    url: '/images/lb-ui/flags/irl-ea7228d7e4060a68a645c349faa436abed3967a9.svg'
  }, {
    iso: 'IRN',
    name: 'Iran, Islamic Republic Of',
    url: '/images/lb-ui/flags/irn-1b41fb9f12843b562b5ed74e42bc332838d30817.svg'
  }, {
    iso: 'IRQ',
    name: 'Iraq',
    url: '/images/lb-ui/flags/irq-b50bbbf1c898bda42e6788fa5853388c13006725.svg'
  }, {
    iso: 'ISL',
    name: 'Iceland',
    url: '/images/lb-ui/flags/isl-1bfebcccdd3c56fae0835c51b8265db8313a9cff.svg'
  }, {
    iso: 'ISR',
    name: 'Israel',
    url: '/images/lb-ui/flags/isr-c200d04d90a28f76ea2b6c829dc9d8dbd508a1aa.svg'
  }, {
    iso: 'ITA',
    name: 'Italy',
    url: '/images/lb-ui/flags/ita-722651eb3a2a73c6ca42d4e6b981f46603f06167.svg'
  }, {
    iso: 'JAM',
    name: 'Jamaica',
    url: '/images/lb-ui/flags/jam-3f5b916a92fb2957bc0ebad9e19d305eeb5fd232.svg'
  }, {
    iso: 'JEY',
    name: 'Jersey',
    url: '/images/lb-ui/flags/jey-fd615742b20bd6a30fb67ca40a08c1b8f9009729.svg'
  }, {
    iso: 'JOR',
    name: 'Jordan',
    url: '/images/lb-ui/flags/jor-5db689b59d679a024d6551501fcfeb50d87938de.svg'
  }, {
    iso: 'JPN',
    name: 'Japan',
    url: '/images/lb-ui/flags/jpn-c474f70578fe5454efbb0fc2099c81e400d69452.svg'
  }, {
    iso: 'KAZ',
    name: 'Kazakhstan',
    url: '/images/lb-ui/flags/kaz-04fde4f4b7158fe6eae23e6b553e5447661ddf20.svg'
  }, {
    iso: 'KEN',
    name: 'Kenya',
    url: '/images/lb-ui/flags/ken-4f53898a57871d32e838e657a81225e4c39efcc4.svg'
  }, {
    iso: 'KGZ',
    name: 'Kyrgyzstan',
    url: '/images/lb-ui/flags/kgz-fdc2d36eb4e8cdf861a1c52b5b5425bdf25f5af0.svg'
  }, {
    iso: 'KHM',
    name: 'Cambodia',
    url: '/images/lb-ui/flags/khm-3f6ac3a87b84df781f1e14dce5feae3d0b53f1ba.svg'
  }, {
    iso: 'KIR',
    name: 'Kiribati',
    url: '/images/lb-ui/flags/kir-53fdaeebc96af707252cc61b6e9423e523cd55d8.svg'
  }, {
    iso: 'KNA',
    name: 'Saint Kitts And Nevis',
    url: '/images/lb-ui/flags/kna-6bb13605362952ba32ef4131fcad68cb68af5917.svg'
  }, {
    iso: 'KOR',
    name: 'Korea, Republic Of',
    url: '/images/lb-ui/flags/kor-39be1f46d29cd390a30f3f07b936facca9bf9f02.svg'
  }, {
    iso: 'KWT',
    name: 'Kuwait',
    url: '/images/lb-ui/flags/kwt-585f1471c1d49e7e5ab9666b05980de0e0f77177.svg'
  }, {
    iso: 'LAO',
    name: 'Lao People&#x27;s Democratic Republic',
    url: '/images/lb-ui/flags/lao-bf8246bd6dd7e3b9839632884a2ddcfafdfade20.svg'
  }, {
    iso: 'LBN',
    name: 'Lebanon',
    url: '/images/lb-ui/flags/lbn-3271a9a503247b7a62e504e55496cb128329228e.svg'
  }, {
    iso: 'LBR',
    name: 'Liberia',
    url: '/images/lb-ui/flags/lbr-3f0439c5d9c897cffb7da9dbcb97e0c94f58bf7c.svg'
  }, {
    iso: 'LBY',
    name: 'Libya',
    url: '/images/lb-ui/flags/lby-646b46eb703a548980a08c9aaf0ea9b00fca9d95.svg'
  }, {
    iso: 'LCA',
    name: 'Saint Lucia',
    url: '/images/lb-ui/flags/lca-981cd4039836e4a0f539c90782a9095a5d310f00.svg'
  }, {
    iso: 'LIE',
    name: 'Liechtenstein',
    url: '/images/lb-ui/flags/lie-6818881467ebcdede5d1de937432046a5eeb1b38.svg'
  }, {
    iso: 'LKA',
    name: 'Sri Lanka',
    url: '/images/lb-ui/flags/lka-e96e4cec91e3662774b2379d1035b0549805855a.svg'
  }, {
    iso: 'LSO',
    name: 'Lesotho',
    url: '/images/lb-ui/flags/lso-6591043b84045481f9c202b166de600bd1981b23.svg'
  }, {
    iso: 'LTU',
    name: 'Lithuania',
    url: '/images/lb-ui/flags/ltu-23d5b860dccf8316d48439737fc41448e059a10c.svg'
  }, {
    iso: 'LUX',
    name: 'Luxembourg',
    url: '/images/lb-ui/flags/lux-665cadea8775364aab0d1adcf4f82ebbc426565f.svg'
  }, {
    iso: 'LVA',
    name: 'Latvia',
    url: '/images/lb-ui/flags/lva-aa20fd2086c34bfbe482783d4c03a42b43a9ed01.svg'
  }, {
    iso: 'MAC',
    name: 'Macao',
    url: '/images/lb-ui/flags/mac-118fb546dfb8a237d3ccabca1f775100eead4544.svg'
  }, {
    iso: 'MAF',
    name: 'Saint Martin',
    url: '/images/lb-ui/flags/maf-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'MAR',
    name: 'Morocco',
    url: '/images/lb-ui/flags/mar-929f09a2e679347c0e56e93d73d9471663a61e58.svg'
  }, {
    iso: 'MCO',
    name: 'Monaco',
    url: '/images/lb-ui/flags/mco-2644879d688913db45b2342fc90b62c518dfd3fd.svg'
  }, {
    iso: 'MDA',
    name: 'Moldova',
    url: '/images/lb-ui/flags/mda-831e26b1215634760d695f8365e661158bd0d6bf.svg'
  }, {
    iso: 'MDG',
    name: 'Madagascar',
    url: '/images/lb-ui/flags/mdg-c086e6547c79aa0d99d183f65de57dcaf6600ec1.svg'
  }, {
    iso: 'MDV',
    name: 'Maldives',
    url: '/images/lb-ui/flags/mdv-336a4dac976d36a2c863012af1ac203ca0ae1150.svg'
  }, {
    iso: 'MEX',
    name: 'Mexico',
    url: '/images/lb-ui/flags/mex-58fad08e2921685ff782bf4dc7f22aa2ccac9360.svg'
  }, {
    iso: 'MHL',
    name: 'Marshall Islands',
    url: '/images/lb-ui/flags/mhl-670a6f6e1ef1b8e847836cf061bbbde84895dad0.svg'
  }, {
    iso: 'MKD',
    name: 'Macedonia, The Former Yugoslav Republic Of',
    url: '/images/lb-ui/flags/mkd-8348f8ea42bf5ab408515d3f27e28eee3f44c209.svg'
  }, {
    iso: 'MLI',
    name: 'Mali',
    url: '/images/lb-ui/flags/mli-1b5c0ab97af85afa8741103b285e04928a4e21e3.svg'
  }, {
    iso: 'MLT',
    name: 'Malta',
    url: '/images/lb-ui/flags/mlt-8256b7eef959816e90db60982ec3911fcfc77627.svg'
  }, {
    iso: 'MMR',
    name: 'Myanmar',
    url: '/images/lb-ui/flags/mmr-2a38cbcb30fc9de9f0cd5950c87210b2cd78cc91.svg'
  }, {
    iso: 'MNE',
    name: 'Montenegro',
    url: '/images/lb-ui/flags/mne-ec9989da494caeed8fcedf814140272d017dae7b.svg'
  }, {
    iso: 'MNG',
    name: 'Mongolia',
    url: '/images/lb-ui/flags/mng-562b7d789205e486804c96802783d5f28a623bab.svg'
  }, {
    iso: 'MNP',
    name: 'Northern Mariana Islands',
    url: '/images/lb-ui/flags/mnp-0e329de922d410d9d39a18c9df6c028e75a9e957.svg'
  }, {
    iso: 'MOZ',
    name: 'Mozambique',
    url: '/images/lb-ui/flags/moz-103c2257df6d536e922f53013534f65f60f94dd9.svg'
  }, {
    iso: 'MRT',
    name: 'Mauritania',
    url: '/images/lb-ui/flags/mrt-1a5af7335ea667b3bba304a858588e5ca249b921.svg'
  }, {
    iso: 'MSR',
    name: 'Montserrat',
    url: '/images/lb-ui/flags/msr-d4b5c328de4717db7412559a388b43c39632f8d1.svg'
  }, {
    iso: 'MTQ',
    name: 'Martinique',
    url: '/images/lb-ui/flags/mtq-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'MUS',
    name: 'Mauritius',
    url: '/images/lb-ui/flags/mus-ee323be012926d394edc7afebbeddb34d94e0bbe.svg'
  }, {
    iso: 'MWI',
    name: 'Malawi',
    url: '/images/lb-ui/flags/mwi-562d3191f36288b7c721c3bbe10b8e3efe923d10.svg'
  }, {
    iso: 'MYS',
    name: 'Malaysia',
    url: '/images/lb-ui/flags/mys-bea32ea1dc662b08af747c66022cd86e06a19393.svg'
  }, {
    iso: 'MYT',
    name: 'Mayotte',
    url: '/images/lb-ui/flags/myt-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'NAM',
    name: 'Namibia',
    url: '/images/lb-ui/flags/nam-b9635a766ae61cfc2fcdd2e881ba8ba58627f0eb.svg'
  }, {
    iso: 'NCL',
    name: 'New Caledonia',
    url: '/images/lb-ui/flags/ncl-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'NER',
    name: 'Niger',
    url: '/images/lb-ui/flags/ner-a7fd8aadd31312aea7df042d661eb208a535cdc4.svg'
  }, {
    iso: 'NFK',
    name: 'Norfolk Island',
    url: '/images/lb-ui/flags/nfk-612c4df2b09e32b2854b856198b0cd8ba2e6cae6.svg'
  }, {
    iso: 'NGA',
    name: 'Nigeria',
    url: '/images/lb-ui/flags/nga-0d5edebd857bed928c0d227df07146e9f9e1d869.svg'
  }, {
    iso: 'NIC',
    name: 'Nicaragua',
    url: '/images/lb-ui/flags/nic-a0eef2b81f016a55181c272bcbdb0c5184f848e0.svg'
  }, {
    iso: 'NIU',
    name: 'Niue',
    url: '/images/lb-ui/flags/niu-c19bf18567b4a96b064b4db3113512c793844c2f.svg'
  }, {
    iso: 'NLD',
    name: 'Netherlands',
    url: '/images/lb-ui/flags/nld-3d1fb1833eea1edac4d4968fe148711685a5973a.svg'
  }, {
    iso: 'NOR',
    name: 'Norway',
    url: '/images/lb-ui/flags/nor-00908b7c4253d5c77985283d3c4e2f9dadb2b71f.svg'
  }, {
    iso: 'NPL',
    name: 'Nepal',
    url: '/images/lb-ui/flags/npl-8d0232e6203ca29d10f2ccefb72916f1d60970ff.svg'
  }, {
    iso: 'NRU',
    name: 'Nauru',
    url: '/images/lb-ui/flags/nru-da975a771dc73c74a8b24328e91c0e852ebac487.svg'
  }, {
    iso: 'NZL',
    name: 'New Zealand',
    url: '/images/lb-ui/flags/nzl-98b0f9115d43eaf4cc7b35bf3ee81d485693cc3e.svg'
  }, {
    iso: 'OMN',
    name: 'Oman',
    url: '/images/lb-ui/flags/omn-57162412e97a950ea1bbaf451ace4eaa8a8dbdc2.svg'
  }, {
    iso: 'PAK',
    name: 'Pakistan',
    url: '/images/lb-ui/flags/pak-d9ff3e5cca33945b16c77a873e18899f7b32983b.svg'
  }, {
    iso: 'PAN',
    name: 'Panama',
    url: '/images/lb-ui/flags/pan-b0eaf9ae5ae7c80c1b461cbb9dd20fcf406a3fae.svg'
  }, {
    iso: 'PCN',
    name: 'Pitcairn',
    url: '/images/lb-ui/flags/pcn-a604c1e57f8b82c8135ca55ba8d93664d6655eb6.svg'
  }, {
    iso: 'PER',
    name: 'Peru',
    url: '/images/lb-ui/flags/per-c0adbfbd69069ec40d757ba189d9d91c54c172d0.svg'
  }, {
    iso: 'PHL',
    name: 'Philippines',
    url: '/images/lb-ui/flags/phl-7b8daaa38738b11aff26fea4664c909e84d0d9ee.svg'
  }, {
    iso: 'PLW',
    name: 'Palau',
    url: '/images/lb-ui/flags/plw-9ff808e337e29411185e063a401c0e907640a3f6.svg'
  }, {
    iso: 'PNG',
    name: 'Papua New Guinea',
    url: '/images/lb-ui/flags/png-8c1e060c1b9ca7943b71941956944b96fc0bca28.svg'
  }, {
    iso: 'POL',
    name: 'Poland',
    url: '/images/lb-ui/flags/pol-783b6fc81468df107d296ae86f665d49c48e67a8.svg'
  }, {
    iso: 'PRI',
    name: 'Puerto Rico',
    url: '/images/lb-ui/flags/pri-caef2df09257f7bfc2d092a0b590f9452770b657.svg'
  }, {
    iso: 'PRK',
    name: 'Korea, Democratic People&#x27;s Republic Of',
    url: '/images/lb-ui/flags/prk-3a4bbbfe0ce004d9ee9e013f9966d4edec01614e.svg'
  }, {
    iso: 'PRT',
    name: 'Portugal',
    url: '/images/lb-ui/flags/prt-aded9719c71178f3b72d9ac22f714b4c0ba328be.svg'
  }, {
    iso: 'PRY',
    name: 'Paraguay',
    url: '/images/lb-ui/flags/pry-f33cadf4686a6d54dbf77c612de1cb99f66b3cd9.svg'
  }, {
    iso: 'PSE',
    name: 'Palestinian Territory, Occupied',
    url: '/images/lb-ui/flags/pse-2fe254f2cf383f980a3a6021ee5dddd0cf5cf71d.svg'
  }, {
    iso: 'PYF',
    name: 'French Polynesia',
    url: '/images/lb-ui/flags/pyf-f50429cdbe5804fd982e82d9ee04df8fda5da8fd.svg'
  }, {
    iso: 'QAT',
    name: 'Qatar',
    url: '/images/lb-ui/flags/qat-900134bf03b917af582ea3035a88da259adcf35a.svg'
  }, {
    iso: 'REU',
    name: 'Reunion',
    url: '/images/lb-ui/flags/reu-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'ROU',
    name: 'Romania',
    url: '/images/lb-ui/flags/rou-78f88741a991f5c2c7c4ddc912126b8dc35c29cb.svg'
  }, {
    iso: 'RUS',
    name: 'Russian Federation',
    url: '/images/lb-ui/flags/rus-d120b78db863de3a5a78183455721626f5fad944.svg'
  }, {
    iso: 'RWA',
    name: 'Rwanda',
    url: '/images/lb-ui/flags/rwa-19a5f97b98b847e14f78738f3ce085deac81ec8b.svg'
  }, {
    iso: 'SAU',
    name: 'Saudi Arabia',
    url: '/images/lb-ui/flags/sau-06474df35c73a1fecdf3efb9f544d8e315f79a2f.svg'
  }, {
    iso: 'SCO',
    name: '',
    url: '/images/lb-ui/flags/sco-9e254cc11493e53ecad295fd35df5b854c3dcc03.svg'
  }, {
    iso: 'SDN',
    name: 'Sudan',
    url: '/images/lb-ui/flags/sdn-d0834746a07e5642e7104a83fb9fef5823b9ac6a.svg'
  }, {
    iso: 'SEN',
    name: 'Senegal',
    url: '/images/lb-ui/flags/sen-300cdc4d1bac3375c47afefd85b87d5d1081e798.svg'
  }, {
    iso: 'SGP',
    name: 'Singapore',
    url: '/images/lb-ui/flags/sgp-71c7cf63304e1b6e47e1ae63a5a204bb77ca4b65.svg'
  }, {
    iso: 'SGS',
    name: 'South Georgia And The South Sandwich Islands',
    url: '/images/lb-ui/flags/sgs-be4cd1cee0a62c1d6951535c07123dbedd91ec2f.svg'
  }, {
    iso: 'SHN',
    name: 'Saint Helena, Ascension And Tristan Da Cunha',
    url: '/images/lb-ui/flags/shn-37a6bf73548bc39ecdfec0d95103e9f21f6c963a.svg'
  }, {
    iso: 'SJM',
    name: 'Svalbard And Jan Mayen',
    url: '/images/lb-ui/flags/sjm-00908b7c4253d5c77985283d3c4e2f9dadb2b71f.svg'
  }, {
    iso: 'SLB',
    name: 'Solomon Islands',
    url: '/images/lb-ui/flags/slb-f41f93edd7610b3fcbaff6487b65acf176f2f6e1.svg'
  }, {
    iso: 'SLE',
    name: 'Sierra Leone',
    url: '/images/lb-ui/flags/sle-d52e7a76fd14061f4f8230e84f63a41192dbec04.svg'
  }, {
    iso: 'SLV',
    name: 'El Salvador',
    url: '/images/lb-ui/flags/slv-d5e27b5b9982ec77aae7160d9c959151514afab3.svg'
  }, {
    iso: 'SMR',
    name: 'San Marino',
    url: '/images/lb-ui/flags/smr-0104dfbb943355698bce1437b71ec0fbc45159d1.svg'
  }, {
    iso: 'SOM',
    name: 'Somalia',
    url: '/images/lb-ui/flags/som-2ff49c5a7e4ede83a7711711ce816250b598242d.svg'
  }, {
    iso: 'SPM',
    name: 'Saint Pierre And Miquelon',
    url: '/images/lb-ui/flags/spm-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'SRB',
    name: 'Serbia',
    url: '/images/lb-ui/flags/srb-1b6945bd18f257fc4b6e4b81d5f4238aecedf696.svg'
  }, {
    iso: 'SSD',
    name: 'South Sudan',
    url: '/images/lb-ui/flags/ssd-553f1d859bef4362bdcb40f533cbce9902469444.svg'
  }, {
    iso: 'STP',
    name: 'Sao Tome and Principe',
    url: '/images/lb-ui/flags/stp-707e512ee882390254ebb2f7eb881c0b849bf26f.svg'
  }, {
    iso: 'SUR',
    name: 'Suriname',
    url: '/images/lb-ui/flags/sur-e4e44ad7f39cfb5e6cbc9c26a1992f43b81c7908.svg'
  }, {
    iso: 'SVK',
    name: 'Slovakia',
    url: '/images/lb-ui/flags/svk-a86dc4a7320f662739d4e4dc67f950fc81164ed7.svg'
  }, {
    iso: 'SVN',
    name: 'Slovenia',
    url: '/images/lb-ui/flags/svn-3055a6a2e6462980d89e0d710408c7b8011af50b.svg'
  }, {
    iso: 'SWE',
    name: 'Sweden',
    url: '/images/lb-ui/flags/swe-4275e92e33f4da69037c3e6090cb1fe5ca962097.svg'
  }, {
    iso: 'SWZ',
    name: 'Swaziland',
    url: '/images/lb-ui/flags/swz-87bc09597f5513f02a6cc6d43076b45392564b62.svg'
  }, {
    iso: 'SXM',
    name: 'Sint Maarten',
    url: '/images/lb-ui/flags/sxm-2790962e1b9f745d7e50ac0dbc772d46b83763bd.svg'
  }, {
    iso: 'SYC',
    name: 'Seychelles',
    url: '/images/lb-ui/flags/syc-0eba876da3b611cdc8cb33c40f6718d6c2ab922d.svg'
  }, {
    iso: 'SYR',
    name: 'Syrian Arab Republic',
    url: '/images/lb-ui/flags/syr-4b135e7e489b25116a007c3c9137d91998c5eb73.svg'
  }, {
    iso: 'TCA',
    name: 'Turks And Caicos Islands',
    url: '/images/lb-ui/flags/tca-df6ff8899a39be5adbc60ee9206db1e808b4bd28.svg'
  }, {
    iso: 'TCD',
    name: 'Chad',
    url: '/images/lb-ui/flags/tcd-25235bbd80329648cad48314c25a34e411291501.svg'
  }, {
    iso: 'TGO',
    name: 'Togo',
    url: '/images/lb-ui/flags/tgo-4a7bfe0569bb974e63b4db6a2bdfafab343838dc.svg'
  }, {
    iso: 'THA',
    name: 'Thailand',
    url: '/images/lb-ui/flags/tha-a6b98f219b93b1b6ccfa31c28664a38e10b6b75c.svg'
  }, {
    iso: 'TJK',
    name: 'Tajikistan',
    url: '/images/lb-ui/flags/tjk-55b4f1056faa1e767665366324cd01a3c4a4623e.svg'
  }, {
    iso: 'TKL',
    name: 'Tokelau',
    url: '/images/lb-ui/flags/tkl-b1f49f494b5838d74bce3cb527bd601f2314d860.svg'
  }, {
    iso: 'TKM',
    name: 'Turkmenistan',
    url: '/images/lb-ui/flags/tkm-2f833c1fe61785d97be1a826bdc638d51f90931e.svg'
  }, {
    iso: 'TLS',
    name: 'Timor-Leste, Democratic Republic of',
    url: '/images/lb-ui/flags/tls-814f1d2f1a06ed6c40e108801dcd3ac6bfd3cad7.svg'
  }, {
    iso: 'TON',
    name: 'Tonga',
    url: '/images/lb-ui/flags/ton-edd5c6e1b152fa98a8a556d06230532ee1ab49c4.svg'
  }, {
    iso: 'TTO',
    name: 'Trinidad And Tobago',
    url: '/images/lb-ui/flags/tto-ea3eb82d539ca005212599c123b7402eb22d4d06.svg'
  }, {
    iso: 'TUN',
    name: 'Tunisia',
    url: '/images/lb-ui/flags/tun-b3283c30844242755eda5d13d394bc1ebd4b7b35.svg'
  }, {
    iso: 'TUR',
    name: 'Turkey',
    url: '/images/lb-ui/flags/tur-54174060f5dc82eadc718978873a3e81acf86790.svg'
  }, {
    iso: 'TUV',
    name: 'Tuvalu',
    url: '/images/lb-ui/flags/tuv-91bfdb3b3a903a86a5811bd2efadee44c0d850cf.svg'
  }, {
    iso: 'TWN',
    name: 'Taiwan',
    url: '/images/lb-ui/flags/twn-deeb3fc90cc519a458ffd018a64c4ba856e7eb58.svg'
  }, {
    iso: 'TZA',
    name: 'Tanzania, United Republic Of',
    url: '/images/lb-ui/flags/tza-01f8866d25486013fcae993a5555a36a62ce901b.svg'
  }, {
    iso: 'UGA',
    name: 'Uganda',
    url: '/images/lb-ui/flags/uga-a2e5a71a4378f4d9df8eaccb44e3487c53dbf515.svg'
  }, {
    iso: 'UKR',
    name: 'Ukraine',
    url: '/images/lb-ui/flags/ukr-2bb0ebed1b48830f834e5a7d9adfc5030ebada26.svg'
  }, {
    iso: 'UMI',
    name: 'United States Minor Outlying Islands',
    url: '/images/lb-ui/flags/umi-cc84699b70a14cfc4094bd0c76eada9ea5f7ef26.svg'
  }, {
    iso: 'UN',
    name: '',
    url: '/images/lb-ui/flags/un-29ee9e47b729ca055cdb1cc33db43852c7f1af02.svg'
  }, {
    iso: 'URY',
    name: 'Uruguay',
    url: '/images/lb-ui/flags/ury-8858c6ce2432034e54149f05bc06f7a72eb3bf97.svg'
  }, {
    iso: 'USA',
    name: 'United States',
    url: '/images/lb-ui/flags/usa-ea32ab72edf6a52b241f459e957ce7cc914e1498.svg'
  }, {
    iso: 'UZB',
    name: 'Uzbekistan',
    url: '/images/lb-ui/flags/uzb-6beba26c3988435061c39e8e5e8a800780b6ae35.svg'
  }, {
    iso: 'VAT',
    name: 'Vatican City State',
    url: '/images/lb-ui/flags/vat-ba4d32874a8622833e4acb806d50528a49974103.svg'
  }, {
    iso: 'VCT',
    name: 'Saint Vincent And The Grenadines',
    url: '/images/lb-ui/flags/vct-05e002bd1f6971cd7496eb1cf0a0991d8f36a995.svg'
  }, {
    iso: 'VEN',
    name: 'Venezuela, Bolivarian Republic Of',
    url: '/images/lb-ui/flags/ven-fc6663773e4074c7736c409d46fc0e5802cf9a86.svg'
  }, {
    iso: 'VGB',
    name: 'Virgin Islands (British)',
    url: '/images/lb-ui/flags/vgb-20e3443415b8e733fb0368e0de089f17d23c88bc.svg'
  }, {
    iso: 'VIR',
    name: 'Virgin Islands (US)',
    url: '/images/lb-ui/flags/vir-cf407d26ddfaee80097761b63dc91bae83860ee3.svg'
  }, {
    iso: 'VNM',
    name: 'Viet Nam',
    url: '/images/lb-ui/flags/vnm-a1d8ef87531b2be576a73e87a609d25402272c47.svg'
  }, {
    iso: 'VUT',
    name: 'Vanuatu',
    url: '/images/lb-ui/flags/vut-cf036f9140a91389ff8dec8a750750c31e512ceb.svg'
  }, {
    iso: 'WAL',
    name: '',
    url: '/images/lb-ui/flags/wal-91d088ad595030303c5bd7fb4404bf96229b9531.svg'
  }, {
    iso: 'WLF',
    name: 'Wallis And Futuna',
    url: '/images/lb-ui/flags/wlf-c75acfdd9d4469b0e9994296b6a4cd181389633e.svg'
  }, {
    iso: 'WSM',
    name: 'Samoa',
    url: '/images/lb-ui/flags/wsm-10fdae0da2f5a0ca2169a3bb6638a457bff99879.svg'
  }, {
    iso: 'YEM',
    name: 'Yemen',
    url: '/images/lb-ui/flags/yem-ab10b19ae96651a59ad17d27cad8a1297c42d15f.svg'
  }, {
    iso: 'ZAF',
    name: 'South Africa',
    url: '/images/lb-ui/flags/zaf-905cac1908a36b1cbab2fb0ade0a1b805ea87a34.svg'
  }, {
    iso: 'ZMB',
    name: 'Zambia',
    url: '/images/lb-ui/flags/zmb-792fc9034428c3569c402143261bb5d7ac59b440.svg'
  }, {
    iso: 'ZWE',
    name: 'Zimbabwe',
    url: '/images/lb-ui/flags/zwe-8acaa1aebadb73c9757f5f79f3c743c559e15631.svg'
  }];

  svs.lb_ui.flags.getFlag = function (iso, key) {
    if (iso) {
      var flag = availiableFlags.filter(function (item) {
        return item.iso.toLowerCase() === iso.toLowerCase();
      })[0];

      if (flag) {
        var value = cdn + flag.url;

        if (typeof key === 'string' || key instanceof String) {
          value = flag[key];
        }

        return value;
      } else {
        return 'no-flag-found.svg';
      }
    }
  }; 


  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = svs.lb_ui.flags;
  }
})(svs);
 })(window);